<!--begin::Auth Header-->
<div id="kt_app_header" class="app-header bg-dark m-0 w-100" style="left:0;">
	<!--begin::Auth Header container-->
	<div class="app-container container-fluid d-flex align-items-stretch justify-content-center" id="kt_app_header_container">
		<!--begin::Mobile logo-->
		<div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
			<img alt="Logo" src="/assets/media/logos/default-dark.svg" class="h-100 py-3 app-sidebar-logo-default" />
			<img alt="Logo" src="/assets/media/logos/default-small.svg" class="h-100 py-3 app-sidebar-logo-minimize" />
		</div>
		<!--end::Mobile logo-->
	</div>
	<!--end::Auth Header container-->
</div>
<!--end::Auth Header-->